import { BaseIntegrationProps } from '../../BaseIntegrationProps';
import { IntegrationType } from '../../IntegrationType';

export class NoneIntegrationProps extends BaseIntegrationProps {

    protected integrationType = IntegrationType.NONE;

    constructor(root: HTMLElement, backupTenantId: string | null) {
        super(root);
        if (!this.tenantId && backupTenantId) {
            this.tenantId = backupTenantId;
        }
    }
    getSessionHeaders(): { [key: string]: unknown; } {
        return {};
    }
    getProductAdminType(): string {
        return 'admin';
    }
    getMissingPropertyError(): Error | null {
        if (this.tenantId) {
            return null;
        }
        return new Error('No tenant id defined');
    }
}
